import {Form, Input, Modal} from "antd";
import {useState} from "react";
import {DialogProps} from "components/Modal/DialogProps";
import {password, required} from "utilities/formRules";
import {useEditUser} from "hooks/useEditUser";

interface Props {
  userId: number
}

export const EditPasswordDialog = ({ open, onClose, userId }: DialogProps & Props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const editUser = useEditUser();

  const handleOk = async () => {
    const values = await form.validateFields();
    if (values.password !== values.password2) {
      alert('Passwords do not match');
      return;
    }
    setLoading(true);
    await editUser({
      userId,
      password: values.password
    });
    setLoading(false);
    onClose();
  };

  return <Modal title="Change password"
                open={open}
                onOk={handleOk}
                confirmLoading={loading}
                onCancel={onClose}
  >
    <Form form={form} layout="vertical" requiredMark={false}>
      <Form.Item name="password" label="New password" rules={password}>
        <Input type='password' />
      </Form.Item>
      <Form.Item name="password2" label="Confirm new password" rules={required}>
        <Input type='password' />
      </Form.Item>
    </Form>
  </Modal>
}